const hivStatuses = [
  {
    label: 'Positive',
    value: 'Positive',
  },
  {
    label: 'Negative',
    value: 'Negative',
  },
  {
    label: 'Unknown',
    value: 'Unknown',
  },
];

export default hivStatuses;

// SELECT
// GROUP_CONCAT(
//     CONCAT(
//         "  {\n",
//             "    label: '", label, "',\n"
//             "    value: '", `value`, "',\n"
//         '  },'
//     )
//     SEPARATOR
//     "\n"
// )
// FROM `civicrm_option_value`
// WHERE option_group_id=186